import React from "react";
import { Card } from "react-bootstrap";
import "./ProgramItem.css";
import { FaSignal, FaClock } from "react-icons/fa";
import logo from "../../assets/python.png";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next"; // Importer useTranslation

function ProgramItem(props) {
  const { t } = useTranslation(); // Assigner useTranslation à {t}
  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate("/programs/" + props.id);
  };

  return (
    <Card
      onClick={handleCardClick}
      className="shadow-sm border-0 rounded program-card"
    >
      <Card.Img
        variant="top"
        src={props.imageUrl ? props.imageUrl : logo}
        className="program-card-img"
      />
      <Card.Body className="text-center">
        {props.categorie}
        <h5 className="mt-2">{props.title}</h5>
        <p className="text-muted">{props.description}</p>
        <div className="d-flex justify-content-center text-muted mt-3">
          <FaSignal className="me-2" /> {props.level}
          <FaClock className="ms-4 me-2" /> {props.duration} {t("hours")}
        </div>
      </Card.Body>
    </Card>
  );
}

export default ProgramItem;
